module.exports = __webpack_public_path__ + "static/img/port (4).79524830.png";